import React from 'react'
import { Radio } from 'antd'
import styles from './MyRadioButton.module.css'

interface IProps {
  list: Array<{ value: string | number; label: string }>
  defaultValue?: string | number
  value?: string | number
  onChange?: (value: string | number) => void
}
export const MyRadioButton: React.FC<IProps> = ({
  list,
  value,
  defaultValue,
  onChange,
}) => {
  return (
    <Radio.Group
      defaultValue={defaultValue}
      buttonStyle="solid"
      className={styles.wrap}
      value={value}
      onChange={e => {
        onChange?.(e.target.value)
      }}
    >
      {list?.map(item => (
        <Radio.Button key={item.value} value={item.value}>
          {item.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  )
}
